import React from "react";
import { Autocomplete, Card, FilterBar, Switch } from "@sscs/ui";
import { Permission } from "Constants";
import { initFilter } from "../../hooks/usePolicyFilter";
import { Filter, NormalizedPolicies, PolicyId } from "../../types";

type TableToolbarProps = {
  filter: Filter;
  count: number;
  isDisabled: boolean;
  onFilterChange: (value: Filter) => void;
  onFilterReset: () => void;
  policies?: NormalizedPolicies;
  policyIds: PolicyId[];
  permissions: Permission[];
};

const TableToolbar = ({
  filter,
  count,
  isDisabled,
  onFilterChange,
  onFilterReset,
  policies,
  policyIds,
}: TableToolbarProps): React.JSX.Element => {
  return (
    <Card.Filters
      found={{
        id: "policy-clear-filters",
        count,
        initialFilters: initFilter,
        activeFilters: filter,
        onClear: onFilterReset,
      }}
    >
      <FilterBar
        filters={[
          {
            id: "policy-id",
            grow: 1,
            minWidth: "260px",
            control: (
              <Autocomplete
                options={policyIds}
                isClearAlwaysVisible={filter.policyId !== initFilter.policyId}
                disabled={isDisabled}
                getOptionLabel={(policyId) =>
                  `${policyId} - ${policies?.[policyId]?.description ?? ""}`
                }
                onChange={(_, value) => {
                  onFilterChange({ ...filter, policyId: value });
                }}
                value={filter.policyId}
                placeholder="Search"
              />
            ),
          },
          {
            id: "edited-only",
            fit: true,
            control: (
              <Switch
                disabled={isDisabled}
                label="Show edited only"
                id="edited-only"
                name="edited-only"
                checked={filter.showEdited}
                onChange={(event) => {
                  onFilterChange({
                    ...filter,
                    showEdited: event.target.checked,
                  });
                }}
              />
            ),
          },
          {
            id: "customized-only",
            fit: true,
            control: (
              <Switch
                disabled={isDisabled}
                label="Show customized levels only"
                id="customized-only"
                name="customized-only"
                checked={filter.showCustomized}
                onChange={(event) => {
                  onFilterChange({
                    ...filter,
                    showCustomized: event.target.checked,
                  });
                }}
              />
            ),
          },
        ]}
      />
    </Card.Filters>
  );
};

export default TableToolbar;
